import React from 'react';
import { MapPin, Clock, Video, Navigation, ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const VisitUs = () => {
  const { t } = useLanguage();
  const googleMapsUrl = 'https://www.google.com/maps/dir/?api=1&destination=Am+Klagesmarkt+29,+30159+Hannover';

  return (
    <section id="visit" className="py-20 bg-[#0f2440]">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
              {t('visit.title')}
            </h2>
            <div className="w-20 h-1 bg-sky-400 mx-auto mb-6"></div>
            <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto">
              {t('visit.subtitle')}
            </p>
          </div>

          <div className="grid sm:grid-cols-3 gap-6 mb-10">
            <div className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center" data-testid="visit-when">
              <div className="w-14 h-14 bg-sky-500/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Clock className="w-7 h-7 text-sky-300" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-1">{t('visit.when')}</h3>
              <p className="text-sky-200 font-medium">{t('visit.everySunday')}</p>
              <p className="text-2xl font-bold text-white mt-1">{t('visit.time')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center" data-testid="visit-where">
              <div className="w-14 h-14 bg-sky-500/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <MapPin className="w-7 h-7 text-sky-300" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-1">{t('visit.where')}</h3>
              <p className="text-sky-200 font-medium">{t('visit.address')}</p>
              <p className="text-white/80 mt-1">{t('visit.city')}</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center" data-testid="visit-online">
              <div className="w-14 h-14 bg-sky-500/20 rounded-xl flex items-center justify-center mx-auto mb-4">
                <Video className="w-7 h-7 text-sky-300" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-1">{t('visit.online')}</h3>
              <p className="text-sky-200 font-medium">{t('visit.livestream')}</p>
              <p className="text-white/80 mt-1">{t('visit.everySunday')}</p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer" data-testid="visit-route-btn"
              className="px-8 py-4 bg-white text-[#0f2440] rounded-lg font-semibold hover:bg-sky-50 transition-all hover:scale-105 hover:shadow-2xl flex items-center gap-3 text-lg">
              <Navigation className="w-5 h-5" />{t('visit.route')}
            </a>
            <button onClick={() => document.getElementById('livestream')?.scrollIntoView({ behavior: 'smooth' })}
              data-testid="visit-online-btn"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-lg font-semibold hover:bg-white/20 transition-all hover:scale-105 flex items-center gap-3 text-lg">
              <ExternalLink className="w-5 h-5" />{t('visit.joinOnline')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisitUs;
